import React, { useEffect } from 'react';


import Typed from 'typed.js';
import GLightbox from 'glightbox';
import Swiper from 'swiper';
import PureCounter from '@srexi/purecounterjs';

import hero_img from '../assets/img/hero_bg2.jpg';


const Hero = () => {

    useEffect(() => {
        // Código para inicializar tus scripts aquí

        // Ejemplo para inicializar Typed.js
        const typed = new Typed('.typed', {
            strings: ['Web3 Developer', 'Software Engineer', 'Ethical Hacker'],
            loop: true,
            typeSpeed: 100,
            backSpeed: 50,
            backDelay: 2000
        });

        // Ejemplo para inicializar PureCounter
        new PureCounter();
    }, []); // La dependencia vacía asegura que el efecto se ejecute solo después del montaje inicial

    return (
        <div id="hero" className="hero route bg-image" style={{ backgroundImage: `url(${hero_img})` }}>
            <div className="overlay-itro"></div>
            <div className="hero-content display-table">
                <div className="table-cell">
                    <div className="container">
                        <h1 className="hero-title mb-4">I am Mateu Joan</h1>
                        <p className="hero-subtitle"><span className="typed"></span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
